<template>
	<div v-if="localParams.data" class="multi-select-renderer">
		<SelectControl :items="localParams.items || []" title-key="name" item-value="id" :multiple="true" :model-value="selected" :readonly="disabled" :clearable="false" density="compact" :max-displayed-chips="1" @update:model-value="onChange" />
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import SelectControl from '@/components/controls/SelectControl.vue';

// Thin adapter: ag-Grid hands a renderer exactly one `params` prop, so SelectControl cannot be used directly.
// Everything (search header, select-all, overlayTarget-attached menu, chip display) is delegated to it.
// Like SwitchRenderer, this reports intent and never writes into the grid.
// cellRendererParams: { items, disabledField?, onChange }
const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
});

const localParams = ref(props.params);

const selected = computed(() => (Array.isArray(localParams.value.value) ? localParams.value.value : []));
const disabled = computed(() => (localParams.value.disabledField ? Boolean(localParams.value.data?.[localParams.value.disabledField]) : false));

function onChange(next) {
	const value = Array.isArray(next) ? next.map(Number) : [];
	if (value.length === selected.value.length && value.every((id, index) => id === selected.value[index])) return;
	localParams.value.onChange?.({ row: localParams.value.data, field: localParams.value.colDef?.field, value });
}

defineExpose({
	refresh(newParams) {
		localParams.value = newParams;
		return true;
	},
});
</script>

<style lang="scss">
.multi-select-renderer {
	display: flex;
	align-items: center;
	height: 100%;

	.v-select {
		width: 100%;
		max-width: 100%;
		min-width: 100%;

		.v-field,
		.v-input__control {
			width: 100%;
		}
	}
}
</style>
